import { render, staticRenderFns } from "./BusView.vue?vue&type=template&id=5bc33ef7&"
import script from "./BusView.vue?vue&type=script&lang=js&"
export * from "./BusView.vue?vue&type=script&lang=js&"
import style0 from "./BusView.vue?vue&type=style&index=0&id=5bc33ef7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports